import { LOGGER } from "../utils/logger";
import useAxios from "../utils/interceptor";

const PermissionApi = () => {
  const axiosHandler = useAxios();

  const getAll = async () => {
    try {
      const res = await axiosHandler.get(`permission/all`);
      return res?.data;
    } catch (error) {
      LOGGER.error({ text: "getAll api ", error });
    }
  };

  const getAllPaginated = async ({ page = 0, pageSize = 10, search = "" }) => {
    try {
      const res = await axiosHandler.get(
        `permission?page=${page}&pageSize=${pageSize}&search=${search}`
      );
      return res?.data;
    } catch (error) {
      LOGGER.error({ text: "getAll api ", error });
    }
  };

  const create = async (body) => {
    try {
      const res = await axiosHandler.post(`permission`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "create api ", error });
      return {
        text: "create api error",
        error,
      };
    }
  };

  const update = async (body, id) => {
    try {
      const res = await axiosHandler.put(`permission/${id}`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "update api ", error });
    }
  };

  const remove = async (id) => {
    try {
      const res = await axiosHandler.delete(`permission/${id}`);
      return res;
    } catch (error) {
      LOGGER.error({ text: "remove api ", error });
    }
  };

  return {
    getAllPaginated,
    create,
    getAll,
    update,
    remove,
  };
};

export default PermissionApi;
